import type { Requests } from "../common/request.common";
import type { ProvisionResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const provision = {
    record(data: typeof Requests.Provision.Record.Input) {
        return post<typeof data, ProvisionResponseTypes.Record>(`/provision/record`, data);
    },
    create(data: typeof Requests.Provision.Create.Input) {
        return post<typeof data>("/provision/create", data);
    },
    obtain(id: string) {
        return get<ProvisionResponseTypes.Obtain>(`/provision/obtain/${id}`);
    },
    createTaken(id: string, data: typeof Requests.Provision.CreateTaken.Input) {
        return post<typeof data>(`/provision/create-taken/${id}`, data);
    },
    cancelTaken(id: string, data: typeof Requests.Provision.CancelTaken.Input) {
        return post<typeof data>(`/provision/cancel-taken/${id}`, data);
    },
    cancel(id: string) {
        return postEmpty(`/provision/cancel/${id}`);
    },
    finish(id: string, data: typeof Requests.Provision.UpdateComplete.Input) {
        return post<typeof data>(`/provision/update-complete/${id}`, data);
    },
};
